import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function updateContentModuleReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.UPDATE_CONTENT_MODULE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.UPDATE_CONTENT_MODULE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload
            };
        case t.UPDATE_CONTENT_MODULE_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
